import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "firstFunction1";
const idNext = "firstFunction2";

const next = `
functions:
  - function: Duel
`;

function ManualFirstFunction1({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("group_function") && (
        <div className={`${styles["container"]} ${styles["container-ff1"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-1a" className={`${styles["container__text"]}`}>
            <p>This sidebar lists all functions within your current model.</p>
            <p>
              Click on the default function and change its name to <b>Duel</b>.
            </p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-1a"
            end="group_function"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-ff1"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              In this tutorial, you'll learn how to build a simple model and generate tests. Models
              are organized into functions, which contain parameters and logic.
            </p>
            <p>
              First, change the name of the default function to <b>Duel</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateFirstFunction1 = (root, tutorial, setTutorial) => {
  if (tutorial === id) {
    let { res } = tutorialUtils.validateSingleFunction(root, "Duel");

    if (!res) {
      return false;
    }

    setTutorial(idNext);

    return true;
  }

  return false;
};

export default ManualFirstFunction1;
